import { v4 } from '@lukeed/uuid';
import { Molecule as OCLMolecule } from 'openchemlib/full';
import getAtomsFromMF from '../utilities/getAtomsFromMF';
export function initMolecule(options = {}) {
    const id = options.id || v4();
    const label = options.label || 'p#';
    const molfile = options.molfile || '';
    const mol = OCLMolecule.fromMolfile(molfile);
    const mfInfo = mol.getMolecularFormula();
    return {
        id,
        molfile,
        label,
        mf: mfInfo.formula,
        em: mfInfo.absoluteWeight,
        mw: mfInfo.relativeWeight,
        svg: mol.toSVG(50, 50),
        atoms: getAtomsFromMF(mfInfo.formula),
    };
}
export function toJSON(molecule) {
    const { molfile, label, id } = molecule;
    return {
        molfile,
        label,
        id,
    };
}
